import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { CHARGES_HIDDEN, CONTAINER_ITEMS_NO_SEALS, HIDDEN_FOR_H2 } from '../fields.base';
import { Variant } from '../types';

const H2 = DeclarationHighValueGroupType.H2;

/**
 * Belgium, import (IDMS).
 *
 * R2: nothing in this file can affect NL or FR. Deltas only.
 */
export const beImport: Variant = {
  'generalInfo.group': { present: true },
  'goodShipmentGlobal.customsProcedureType': { present: true },
  'goodShipmentGlobal.customsNationalProcedure': { present: true },
  'goodShipmentGlobal.customsNationalProcedureCode': { present: true },

  'messageInfo.methodOfPayment': { present: true, amendmentLocked: true, rules: HIDDEN_FOR_H2 },
  'messageInfo.deferredPayment': { present: true, amendmentLocked: true, rules: HIDDEN_FOR_H2 },
  'messageInfo.methodOfPaymentVAT': { present: true, amendmentLocked: true, rules: HIDDEN_FOR_H2 },
  'valuationInformationTaxes.valuationMethod': { present: true, rules: HIDDEN_FOR_H2 },

  'messageInfo.security': { present: true, rules: [{ when: { declarationMainType: 'IM' }, then: { present: false } }] },

  'goodShipmentGlobal.preference': { present: true },

  'messageInfo.declarationMainType': { amendmentLocked: true },
  'messageInfo.declarationType': { amendmentLocked: true },
  'consignment.customsSupervisingOffice.referenceNumber': { present: true, amendmentLocked: true },
  'consignment.customsOfficePresentation.referenceNumber': { present: true },
  customer: { amendmentLocked: true },

  'consignment.countryOfDispatch': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },
  'consignment.regionOfDestination': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },

  'transportInformation.arrivalTransportMeans.identificationNumber': { rules: [{ when: { not: { group: H2 } }, then: { present: true } }] },
  'transportInformation.arrivalTransportMeans.typeOfIdentification': { rules: [{ when: { not: { group: H2 } }, then: { present: true } }] },
  'transportInformation.modeOfTransportMeansAtTheBorder': { rules: [{ when: { group: H2 }, then: { present: false } }] },

  chargesDeliveryTerms: { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.CustomsCharges.charges': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.CustomsCharges.currency': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.VATcharges.charges': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.VATcharges.currency': { present: true, rules: CHARGES_HIDDEN },

  'transportInformation.transportEquipment.containers': { items: CONTAINER_ITEMS_NO_SEALS },
};
